const authentication = require('react-azure-adb2c2').default;


// export const update = (values:any) => {

//     const token = authentication.getAccessToken();
//     const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

//     return fetch(url, {
//         method: 'put',
//         body: JSON.stringify(values),
//         headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
//     })
//         .then(res => res)
//         .then(payload => ({ payload }))
//         .catch(error => ({ error }));


// }






export const list = (values: any) => {


  let url = `https://homestationapi.azurewebsites.net/api/RentContractAccounting`;



  // let url = `https://localhost:44341/api/RentContractAccounting`;

  const token = authentication.getAccessToken();

  // alert(url)



  const accountinglist = values.filter((item: any, i: number) => (item.selected === true))


  const accountinglistset = accountinglist.map((item: any, i: number) => ({
    Id: item.id,
    Date: item.date,
    ContractMoney: item.contract_money,
    Name: item.name,
    GlContractId: item.contract_id,
    SectionId: item.section_id === 5 ? 6 : item.section_id === 6 ? 17 : item.section_id,
    Billing: item.tenant,
    DepositAmount: item.deposit_amount,
    AccountNumber: item.account_number,
  }))

  // alert(JSON.stringify(accountinglistset))
  return fetch(url, {
    method: 'post',
    body: JSON.stringify(accountinglistset),

    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

  }).then(response => response.blob())
    .then(payload => ({ payload }))
    // .then(res => res.json())
    // .then(payload => ({ payload }))
    .catch(error => ({ error }));






};











// export const detail = (Id: number) => {

//             const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

//             const token = authentication.getAccessToken();

//             return fetch(url, {
//                 headers: { 'Authorization': 'Bearer ' + token }
//             }).then(res => res.json())
//                 .then(payload => ({ payload }))
//                 .catch(error => ({ error }));


//     }



